import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { FileTextIcon, ZapIcon, GiftIcon, CheckIcon } from 'lucide-react';
import { heroImage } from '../data/content';
const guarantees = ['Garantía de 7 días', 'Mercado Pago, tarjeta o transferencia', 'Sin conocimientos previos'];
export function Hero() {
  const reduceMotion = useReducedMotion();
  return <section id="top" className="w-full bg-forest-900 text-cream-50" data-id="element-91" data-mp="129h0hmovcycw">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 py-16 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:px-8 lg:py-24" data-id="element-92" data-mp="128pg780q2n1x">
        <div data-id="element-93" data-mp="sb1cvtp1w785">
          <p className="font-display text-sm font-bold text-gold-500" data-id="element-94" data-mp="sai4p4p7cx7b">
            Full Tienda · Educación financiera
          </p>
          <h1 className="display-tight mt-5 font-display text-5xl font-extrabold text-cream-50 sm:text-6xl lg:text-[4.25rem]" data-id="element-95" data-mp="nbonp2apio2e">
            Ordená tu dinero
            <br data-id="element-96" data-mp="381xmt2oj9aca" />
            antes de gastarlo.
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-cream-200" data-id="element-97" data-mp="384jtl03lnltg">
            <strong className="font-semibold text-cream-50" data-id="element-98" data-mp="3j924lm8avmuh">
              Sistema de Ahorro: Lo que necesitas para salir adelante.
            </strong>{' '}
            Un programa completo, paso a paso, para controlar tus gastos, salir
            de las cuotas y construir ahorros reales con los ingresos que ya
            tenés.
          </p>

          <ul className="mt-7 flex flex-wrap gap-x-7 gap-y-3 text-sm font-medium text-cream-200" data-id="element-99" data-mp="30iaz4vrfogld">
            <li className="flex items-center gap-2" data-id="element-100" data-mp="358hnqvly413m">
              <FileTextIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-101" data-mp="35a2gqgsm3bzd" />
              6 tomos en PDF
            </li>
            <li className="flex items-center gap-2" data-id="element-102" data-mp="2viy1rh2xrr4j">
              <ZapIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-103" data-mp="2vjq0h0rty4z1" />
              Acceso en minutos
            </li>
            <li className="flex items-center gap-2" data-id="element-104" data-mp="2hl9s75ebk6es">
              <GiftIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-105" data-mp="2ll0fv08ju6f3" />
              6 bonos de regalo
            </li>
          </ul>

          <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-4" data-id="element-106" data-mp="s44hnmgsjjhd">
            <motion.a href="#comprar" className="flex items-center justify-center rounded-md bg-gold-500 px-7 py-4 font-display text-base font-extrabold uppercase tracking-wide text-forest-900 transition-colors duration-150 ease-out hover:bg-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-400" style={{
            fontSize: '24px',
            textAlign: 'center',
            width: '315px',
            height: '52px'
          }} animate={reduceMotion ? undefined : {
            scale: [1, 1.045, 0.995, 1.025, 1]
          }} transition={{
            duration: 0.9,
            times: [0, 0.18, 0.35, 0.5, 0.68],
            ease: 'easeOut',
            repeat: Infinity,
            repeatDelay: 1.9
          }} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.98
          }} data-id="element-107" data-mp="najivs7dilh4">
              Empezar hoy
            </motion.a>
          </div>

          <ul className="mt-9 grid max-w-xl gap-y-2 border-t border-white/10 pt-6 text-sm text-cream-300 sm:grid-cols-2" data-id="element-108" data-mp="218jw9y0aul4f">
            {guarantees.map(item => <li key={item} className="flex items-center gap-2" data-id="element-109" data-mp="2b1hh4asrkm67">
                <CheckIcon className="h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-110" data-mp="2g0c1hh6dqisf" />
                {item}
              </li>)}
          </ul>
        </div>

        <figure className="rounded-2xl border border-white/10 bg-forest-800 p-3 shadow-card sm:p-4" data-id="element-111" data-mp="2p0h7pnzu7b50">
          <img src={heroImage} alt="Sistema de Ahorro: 6 tomos y 6 bonos incluidos, en formato digital" className="w-full rounded-xl object-cover" data-id="element-112" data-mp="2tzlek7zagws6" />
          <figcaption className="mt-4 text-center font-display text-[11px] font-bold uppercase tracking-[0.12em] text-cream-300" data-id="element-113" data-mp="zlkifuv4invs">
            Material 100% digital · descargable e imprimible
          </figcaption>
        </figure>
      </div>
    </section>;
}